import { Col, Grid, Image } from 'antd';

import { ImageWrapper } from './company-logo.styles';

const { useBreakpoint } = Grid;

type CompanyLogoProps = {
  hasCompany: boolean;
  companyImageUrl?: string;
};

export const CompanyLogo = ({
  companyImageUrl,
}: CompanyLogoProps) => {

  const screens = useBreakpoint();

  return (
    <>
      <Col span={screens.lg ? 10 : 'auto'} offset={screens.lg ? 7 : 0}>
        <ImageWrapper className='prflbx'>
          
            <Image
              src={companyImageUrl}
              placeholder={true}
              preview={false}
              style={{ objectFit: 'cover' }}
            />
         
        </ImageWrapper>
      </Col>
    </>
  );
};
